exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-capture-form {\n  overflow: hidden;\n}\n.email-capture-form form {\n  display: flex;\n}\n.email-capture-form form .mr-email-input {\n  -webkit-flex-basis: 100%;\n  flex-basis: 100%;\n}\n.email-capture-form form .mr-btn {\n  height: 45px;\n  padding: 0.5em 1em;\n  margin: 0 0 0 -0.3em;\n}\n@media only screen and (min-width: 0px) and (max-width: 559px) {\n.email-capture-form form {\n    display: block;\n}\n.email-capture-form form .mr-btn {\n    width: 100%;\n    margin: 0.5em 0 0 0;\n    height: initial;\n}\n}\n", ""]);

// exports
